import { render, staticRenderFns } from "./section-divider.vue?vue&type=template&id=2867e828&scoped=true&"
import script from "./section-divider.vue?vue&type=script&lang=js&"
export * from "./section-divider.vue?vue&type=script&lang=js&"
import style0 from "./section-divider.vue?vue&type=style&index=0&id=2867e828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867e828",
  null
  
)

export default component.exports